import { apiProxyRequest } from "Api/apiProxyRequest";

import type { EstimationProject } from "../types";

export const getProjectEstimates = ({
  billingProfileId,
  projectId
}: {
  billingProfileId: string;
  projectId: string;
}) => {
  return apiProxyRequest<EstimationProject>(
    `/billing/profiles/${billingProfileId}/projects/${projectId}/estimate?current_month=true`
  );
};
